import {
    config,
    requestOptions,
    requestTypes,
    sendRequest,
} from "../../../Utilities/Api";

//************************************************** STANDARD API SERVER CALLS ****************************************

class serverQueueApi {

    static getLoanPackingList(queueItemId: string) {
        return sendRequest(
            requestOptions(config.URL + `loan/${queueItemId}/packing-list`,
                requestTypes.GET,
            ),
        );
    }

    static getOrderPackingList(orderId: string) {
        return sendRequest(
            requestOptions(config.URL + `orders/${orderId}/packing-list`,
                requestTypes.GET,
            ),
        );
    }

}

export const packingListApi = config.environment.MODE === config.modes.SERVER ? serverQueueApi : serverQueueApi;
